import sortBy from 'lodash/sortBy';

import {
  ACTIVITIES_COMPONENT_TYPE_COLUMNS,
  ActivitiesComponentType,
} from 'global/constants';
import { ComponentColumns } from '../../component.constants';
import type { InteractiveLessonSectionComponentFragment } from '../../../lesson-builder.graphql.generated';

export function getComponentsOfType<T>({
  components,
  types,
}: {
  components: InteractiveLessonSectionComponentFragment[];
  types: ActivitiesComponentType[];
}) {
  const found: T[] = [];
  sortBy(components, 'sort').forEach(component => {
    if (types.includes(component.type)) {
      found.push(component as T);
    }

    if (component.type === ACTIVITIES_COMPONENT_TYPE_COLUMNS) {
      const columns = component as ComponentColumns;
      columns.columns?.forEach(column => {
        sortBy(column.components, 'sort').forEach(colComponent => {
          if (types.includes(colComponent.type)) {
            found.push(colComponent as T);
          }
        });
      });
    }
  });

  return found;
}
